<div id="preloader">
    <div id="loader"></div>
</div>